
<script>
import moment from "moment";
import { getProjectFullID } from "./formatter.js";
export default {
  filters: {
    projectFullIDFormat(project) {
      return getProjectFullID(project);
    },
    moment(str) {
      return str ? moment(str).format("LLL") : "";
    },
    dateFormat(str) {
      return str ? moment(str).format("YYYY/MM/DD") : "";
    },
    yearMonthFormat(str) {
      return str ? moment(str).format("YYYY/MM") : "";
    },
    weekFormat(str) {
      return moment(str).format("dddd");
    },
    periodFormat(period) {
      if (!period.Begin || !period.End) return "-";
      let LLL = "YYYY/MM/DD HH:mm";
      if (!moment(period.Begin).isSame(period.End, "year"))
        return (
          moment(period.Begin).format(LLL) +
          "~" +
          moment(period.End).format(LLL)
        );
      if (!moment(period.Begin).isSame(period.End, "month"))
        return (
          moment(period.Begin).format("YYYY MM/DD HH:mm") +
          "~" +
          moment(period.End).format("MM/DD HH:mm")
        );

      if (!moment(period.Begin).isSame(period.End, "date")) {
        return (
          moment(period.Begin).format("YYYY MM/DD HH:mm") +
          "~" +
          moment(period.End).format("MM/DD HH:mm")
        );
      } else {
        return (
          moment(period.Begin).format(LLL) +
          "~" +
          moment(period.End).format("HH:mm")
        );
      }

    },
    amountFormat(amount) {
      return (amount + "")
        .split("")
        .reverse()
        .join("")
        .replace(/(\d{3})(?=\d)/g, "$1,")
        .split("")
        .reverse()
        .join("");
    },
    hoursFormat(hours, minutes) {
      if (!minutes) return `${hours}小時`
      if (!hours) return `${minutes}分鐘`
      return `${hours}小時${minutes}分鐘`
    },
    hoursFormatOfTaskWorkingItem(item) {
      var hours = item.ActualHours
      var minutes = item.ActualMinutes
      if (!minutes) return `${hours}小時`
      if (!hours) return `${minutes}分鐘`
      return `${hours}小時${minutes}分鐘`
    }
  }
};
</script>
